import { makeApiRequest } from '../../utils/api-utils';

export const getAllCommunityTags = async () =>
  makeApiRequest('/community-tag/get-all');

export const getCommunityTagById = async (id: string) =>
  makeApiRequest(`/community-tag/get-by-id/${id}`);

export const getCommunityTagsByCommunity = async (communityId: string) =>
  makeApiRequest(`/community-tag/community/${communityId}`);

export const createCommunityTag = async (data: {
  community_id: string;
  tag_id: string;
}) =>
  makeApiRequest('/community-tag/create', {
    method: 'POST',
    body: JSON.stringify(data),
  });

export const deleteCommunityTag = async (id: string) =>
  makeApiRequest(`/community-tag/delete/${id}`, {
    method: 'DELETE',
  });

